import { Fragment } from "react";

import useHqOfferingTypeUSASAdd from "./UseHqOfferingTypeUSASAdd";

import HqOfferingManagementContextLoadingModal from "../../HqOfferingManagementContextLoadingModal";

import OfferingTypeUSASForm from "../../../components/forms/offering/OfferingTypeUSASForm";

import Headings from "@usas/ui-web/components/headings/Headings";

import { SAVING_MSG } from "@usas/ui-web/utils/Constants";

const HqOfferingTypeUSASAdd = () => {
  const {
    isSaving,
    state,
    onSubmitOfferingForm,
    onBackClicked
  } = useHqOfferingTypeUSASAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Add USA Swimming Offering</Headings.H3>
        </div>
      </div>
      {state.offeringObj?.offeringTypeId > 0 &&
        <OfferingTypeUSASForm
          offeringObj={state.offeringObj}
          submitButtonText='Add Offering'
          onSubmitFormCallback={onSubmitOfferingForm}
          onBackClicked={onBackClicked} />
      }
      <HqOfferingManagementContextLoadingModal
        isLoading={isSaving}
        loadingMessage={SAVING_MSG}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default HqOfferingTypeUSASAdd;